import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const useObjectTypeId = () => useContext(PropertyContext).objectTypeId;